import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { MenuConfiguration } from 'src/common/models';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
  selector: 'app-ecommerce-payment-cards',
  templateUrl: './ecommerce-payment-cards.component.html',
  styleUrls: ['./ecommerce-payment-cards.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class EcommercePaymentCardsComponent {
  cards = ContentCacheUtils.menu<MenuConfiguration>()?.paymentOptions ?? [];
}
